import { createResourceStore } from "@/lib/resource";
import type { StockBatch } from "./StockBatch";
import type { Service } from "./Service";
import type { Product } from "./Product";

export interface Sale {
  id: string;
  order_id: string;
  quantity: number;
  selling_price: number;
  status: "pending" | "completed" | "cancelled";
  salable: any;
  salable_type: string;
  salable_id: string;
  salable_name: string;
  // Client attribute mimic for salable_type without the namspaces.
  // Frontend do not need to know about namepsaces things.
  type: string; //
  type_id: string; //
  // Timestamps.
  created_at: string;
  updated_at: string;
}

// Mix of StockBatch and Service. Only the attributed needed for Order
export type Salable = StockBatch | Service;

export type ProductSale = Sale & {
  batchs: StockBatch[];
  product: Product;
};

export type PosSale = Sale | ProductSale;

export const useSale = createResourceStore<Sale>("sales", () => ({
  stats: {
    filters: {
      start_date: null,
      end_date: null,
    },
    total_items_sold: 0,
    total_sales_volume: 0.0,
    total_orders: 0,
    series: {
      labels: [],
      datasets: [],
    },
    top_sold_items: [],
    top_sold_categories: [],
    top_customers: [],
  },
}));
